<template>
  <router-view></router-view>
</template>

<script>
import { mapState } from 'vuex'
export default {
  name: 'app',
  computed: {
    ...mapState(['user'])
  },
  watch: {
    user() {
      if (this.user && this.user.id) {
        this.$router.push({ name: 'Main' })
      } else {
        this.$router.push({ name: 'Login' })
      }
    }
  }
}
</script>

<style>
.box {
  cursor: pointer;
  transition: .5s;
}

.box:hover {
  background-color: #f9f9f9;
  transition: .5s;
}

.swiper-wrapper {
  box-sizing: border-box !important;
}

.swiper-slide .centered {
  flex-direction: column;
}

.swiper-slide img {
  max-height: 300px;
}

.swiper-pagination {
  display: none;
}

.save-content-button .button {
  margin: 0 0 30px 0;
  width: 220px;
}

.delete-pin {
  margin: 10px 0 0;
}

a.button.is-danger {
  height: 36px;
  width: 36px;
}

.mt-10 {
  margin-top: 10px !important;
}

.el-date-table th {
  width: 50px;
  text-align: center;
}

.el-date-picker {
  min-width: 383px !important;
}

.el-date-range-picker {
  min-width: 765px !important;
}

.is-danger input {
  border: 1px solid #ff3860;
}

.with-background-image {
  background-position: center !important;
  background-repeat: no-repeat !important;
  background-size: contain !important;
}
</style>



// WEBPACK FOOTER //
// App.vue?a2e5869e